export default __webpack_public_path__ + "static/media/TDSA-new.f9000289.png";